// extracted by mini-css-extract-plugin
export default {"header":"Footer_header__I0R3a"};